import { useEffect } from 'react'

// Adds .is-revealed to every [data-reveal] block once it scrolls into view, so its [data-reveal-item] children animate in.
export const useReveal = (): void => {
    useEffect(() => {
        const blocks = document.querySelectorAll('[data-reveal]')

        if (!blocks.length) return

        if (!('IntersectionObserver' in window)) {
            blocks.forEach((block) => block.classList.add('is-revealed'))
            return
        }

        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-revealed')
                    observer.unobserve(entry.target)
                }
            }
        }, { rootMargin: '0px 0px -35% 0px', threshold: 0.25 })

        blocks.forEach((block) => observer.observe(block))

        return () => observer.disconnect()
    }, [])
}
